import { render, staticRenderFns } from "./DisputeResolutionFilesEscalated.vue?vue&type=template&id=39d5a421&scoped=true&"
import script from "./DisputeResolutionFilesEscalated.vue?vue&type=script&lang=js&"
export * from "./DisputeResolutionFilesEscalated.vue?vue&type=script&lang=js&"
import style0 from "./DisputeResolutionFilesEscalated.vue?vue&type=style&index=0&id=39d5a421&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d5a421",
  null
  
)

export default component.exports